import { __awaiter, __extends, __generator } from "tslib";
import { Command as $Command } from "@aws-sdk/smithy-client";
import { marshallInput, unmarshallOutput } from "../commands/utils";
var DynamoDBDocumentClientCommand = (function (_super) {
    __extends(DynamoDBDocumentClientCommand, _super);
    function DynamoDBDocumentClientCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DynamoDBDocumentClientCommand.prototype.addMarshallingMiddleware = function (configuration) {
        var _this = this;
        var _a = configuration.translateConfig || {}, marshallOptions = _a.marshallOptions, unmarshallOptions = _a.unmarshallOptions;
        this.clientCommand.middlewareStack.add(function (next) {
            return function (args) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    args.input = marshallInput(this.input, this.inputKeyNodes, marshallOptions);
                    return [2, next(args)];
                });
            }); };
        }, {
            name: "DocumentMarshall",
            step: "initialize",
            override: true,
        });
        this.clientCommand.middlewareStack.add(function (next) {
            return function (args) { return __awaiter(_this, void 0, void 0, function () {
                var deserialized;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, next(args)];
                        case 1:
                            deserialized = _a.sent();
                            deserialized.output = unmarshallOutput(deserialized.output, this.outputKeyNodes, unmarshallOptions);
                            return [2, deserialized];
                    }
                });
            }); };
        }, {
            name: "DocumentUnmarshall",
            step: "deserialize",
            override: true,
        });
    };
    return DynamoDBDocumentClientCommand;
}($Command));
export { DynamoDBDocumentClientCommand };
